import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom"; //useNavigate
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import SchoolIcon from "@mui/icons-material/School";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MenuOpen from "@mui/icons-material/MenuOpen";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import EventNoteIcon from "@mui/icons-material/EventNote";
// import SlowMotionVideoIcon from "@mui/icons-material/SlowMotionVideo";

const Item = ({ title, to, icon, selected, setSelected, style }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.primary[100],
        ...style,
        backgroundColor:
          selected === title ? colors.blueAccent[900] : "transparent",
        borderRadius: "10px",
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography
        style={{
          fontWeight: "bold",
          color: style?.color || colors.primary[100],
          fontSize: "18px",
        }}
      >
        {title}
      </Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const MemberSidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  // const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("ShraddhaEvents");
  // const [isCoursesOpen, setisCoursesOpen] = useState();

  // State variables for visibility
  const [showEvent, setshowEvent] = useState(false);
  const [showSupports, setshowSupports] = useState(false);
  const [showEventVideo, setshowEventVideo] = useState(false);
  const [showSInfinite, setshowSInfinite] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem("Sub");

    if (role === "n") {
      setshowEvent(true);
      setshowSupports(true);
      setshowEventVideo(false);
      setshowSInfinite(true);
    } else if (role === "m") {
      setshowEvent(true);
      setshowSupports(true);
      setshowEventVideo(false);
      setshowSInfinite(true);
    }
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          "& .pro-sidebar-inner": {
            background: `${colors.primary[400]} !important`,
            boxShadow: "2px 0 2px -2px rgba(0, 0, 0, 0.5)",
            marginTop: {
              md: "20px",
              lg: "25px",
              xl: "30px",
            },
            position: isCollapsed ? "fixed" : "fixed",
            height: isCollapsed ? "100vh" : "100vh",
            overflowY: "auto",
            top: isCollapsed ? "40px" : "40px",
            left: 0,
            width: {
              xs: isCollapsed ? "70px" : "220px",
              sm: isCollapsed ? "70px" : "230px",
              md: isCollapsed ? "70px" : "230px",
              lg: isCollapsed ? "70px" : "240px",
            },
            zIndex: isCollapsed ? 999 : 999,
            transition: "all 0.3s ease",
            flexDirection: "column",
          },
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important",
          },
          "& .pro-inner-item": {
            color: `${colors.grey[400]}!important`,
          },
          "& .pro-inner-item:hover": {
            color: "#CBAD5B !important",
          },
          "& .pro-menu-item": {
            color: "#6870fa !important",
            borderRadius: "10px",
          },
          "& .pro-menu-item.active": {
            color: "#6870fa !important",
            backgroundColor: `${colors.blueAccent[900]}!important`,
            borderRadius: "10px",
          },
        }}
      >
        <ProSidebar collapsed={isCollapsed}>
          <Menu iconShape="square">
            <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : <MenuOpen />}
              style={{
                color: colors.grey[100],
              }}
            ></MenuItem>

            <Box>
              {showEvent && (
                <Item
                  title="Events"
                  to="/Member/ShraddhaEvents"
                  icon={<EventNoteIcon style={{ color: "#B09246" }} />}
                  selected={selected}
                  setSelected={setSelected}
                />
              )}
              {showSupports && (
                <Item
                  title="Support"
                  to="/Member/Support"
                  icon={<SupportAgentIcon style={{ color: "#B09246" }} />}
                  selected={selected}
                  setSelected={setSelected}
                />
              )}
              {showEventVideo && (
                <Item
                  title="Events Recording"
                  to="/Member/EventsRecording"
                  icon={<OndemandVideoIcon style={{ color: "#B09246" }} />}
                  selected={selected}
                  setSelected={setSelected}
                />
              )}

              {/* Courses Section (commented out as in original) */}
              {/* <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={handleCoursesToggle}
              >
                <SchoolIcon style={{ marginLeft: "25px", color: "#B09246" }} />

                <Typography
                  paddingLeft={isCollapsed ? "25%" : "0px"}
                  color={colors.primary[100]}
                  sx={{
                    m: "10px 0 5px 15px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Courses
                </Typography>

                {isCoursesOpen ? (
                  <ExpandLessIcon
                    style={{ marginLeft: "auto", color: colors.primary[100] }}
                  />
                ) : (
                  <ExpandMoreIcon
                    style={{ marginLeft: "auto", color: colors.primary[100] }}
                  />
                )}
              </Box> 

              {isCoursesOpen && (
                <>
                  <Box
                    style={{
                      marginLeft: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <Item
                      title="All Courses"
                      to="/Member/ShraddhaCourses"
                      icon={
                        <SlowMotionVideoIcon style={{ color: "#B09246" }} />
                      }
                      selected={selected}
                      setSelected={setSelected}
                      style={{ color: "grey" }}
                    />

                    <Item
                      title="My Courses"
                      to="/Member/MyCourses"
                      icon={<OndemandVideoIcon style={{ color: "#B09246" }} />}
                      selected={selected}
                      setSelected={setSelected}
                      style={{ color: "grey" }}
                    />
                  </Box>
                </>
              )} */}

              <Box
                style={{
                  color: "#868dfb",
                  alignItems: "left",
                  justifyContent: "left",
                  fontSize: "20px",
                  fontWeight: "bolder",
                }}
              >
                {showSInfinite && (
                  <Item
                    title=" Shraddha Infinite"
                    to="/Infinite/Dashboard"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "20px",
                    }}
                    icon={<AllInclusiveIcon style={{ color: "#B09246" }} />}
                    selected={selected}
                    setSelected={setSelected}
                  />
                )}
              </Box>
            </Box>
          </Menu>
        </ProSidebar>
      </Box>
    </Box>
  );
};

export default MemberSidebar;
